import React, { useState, useEffect, useContext } from "react";
import BannerImage1 from "../../images/banner1.jpg";
import BannerImage2 from "../../images/banner2.jpg";
import BannerImage3 from "../../images/banner3.jpg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { CartContextProvider } from "../../context/CartContext";

const Banner = () => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const [isAnimating, setIsAnimating] = useState(false);
	const [isPaused, setIsPaused] = useState(false);
	const { userAvailable } = useContext(CartContextProvider);

	const slides = [
		{
			description: "Elevate Your Style with Premium Hand-crafted Designs",
			image: BannerImage1,
			buttonText: "Shop Collection",
		},
		{
			description: "Discover Minimal Chic & Soft Pastel Aesthetics",
			image: BannerImage2,
			buttonText: "Explore Now",
		},
		{
			description: "Vibrant Floral Accents for Every Occasion",
			image: BannerImage3,
			buttonText: "Find Your Match",
		},
	];

	const nextSlide = () => {
		if (!isAnimating) {
			setIsAnimating(true);
			setCurrentSlide((prev) => (prev + 1) % slides.length);
		}
	};

	const prevSlide = () => {
		if (!isAnimating) {
			setIsAnimating(true);
			setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
		}
	};

	const goToSlide = (index) => {
		if (!isAnimating && index !== currentSlide) {
			setIsAnimating(true);
			setCurrentSlide(index);
		}
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsAnimating(false);
		}, 500);
		return () => clearTimeout(timer);
	}, [currentSlide]);

	useEffect(() => {
		if (!isPaused) {
			const interval = setInterval(() => {
				nextSlide();
			}, 5000);
			return () => clearInterval(interval);
		}
	}, [currentSlide, isPaused, slides.length]);

	return (
		<div
			className="bg-[#fff1f5] w-full py-0 h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] overflow-hidden relative group"
			onMouseEnter={() => setIsPaused(true)}
			onMouseLeave={() => setIsPaused(false)}
		>
			{/* Background Images Layer */}
			<div className="absolute inset-0 z-0">
				{slides.map((slide, index) => (
					<div
						key={index}
						className={`absolute inset-0 transition-opacity duration-1000 ${
							currentSlide === index ? "opacity-100 z-10" : "opacity-0 z-0"
						}`}
					>
						<img
							src={slide.image}
							alt={""}
							className="w-full h-full object-cover object-center"
						/>
					</div>
				))}
			</div>

			{/* Content Layer */}
			<div className="absolute inset-0 z-10 pointer-events-none flex flex-col md:flex-row">
				<div
					className="w-full md:w-1/2 h-full flex flex-col justify-center px-4 sm:px-8 md:pl-20 
					bg-white/50 sm:bg-transparent sm:bg-gradient-to-t md:bg-gradient-to-r from-white/95 via-white/80 to-transparent pointer-events-auto relative"
				>
					{slides.map((slide, index) => (
						<div
							key={index}
							className={`absolute inset-0 p-6 sm:p-8 md:p-0 md:pr-10 lg:pr-20 flex flex-col 
								justify-center transition-opacity duration-700 ease-in-out ${
									currentSlide === index ? "opacity-100 z-10" : "opacity-0 z-0"
								}`}
						>
							<div className="bg-white/80 sm:bg-transparent p-6 sm:p-0 rounded-2xl sm:rounded-none backdrop-blur-sm sm:backdrop-blur-none text-center md:text-left mt-8 sm:mt-0">
								<h2
									className="text-[28px] leading-tight sm:text-4xl md:text-5xl lg:text-6xl tracking-tight sm:tracking-wide font-extrabold text-gray-900
									md:pl-5 lg:pl-8 drop-shadow-md sm:drop-shadow-sm mb-6"
								>
									{slide.description}
								</h2>
								<button
									type="button"
									onClick={() => {
										if (userAvailable) {
											document
												.getElementById("products-section")
												.scrollIntoView({ behavior: "smooth" });
										} else {
											window.location.href = "/auth";
										}
									}}
									className="w-fit mx-auto md:mx-0 bg-gray-900 hover:bg-black text-sm md:text-lg 
									font-semibold text-white md:ml-5 lg:ml-8 flex justify-center 
									items-center rounded-full py-3 sm:py-3 px-8 sm:px-10 uppercase tracking-wider transition-all shadow-xl hover:-translate-y-1"
								>
									{userAvailable ? slide.buttonText : "Sign Up & Save 10%"}
								</button>
							</div>
						</div>
					))}
				</div>
			</div>

			{slides.length > 1 && (
				<>
					<button
						type="button"
						onClick={prevSlide}
						className="absolute left-6 top-1/2 opacity-0 group-hover:opacity-100 -translate-y-1/2 
        bg-white/80 hover:bg-white p-3 rounded-full shadow-lg transition-all z-30"
						aria-label="Previous slide"
					>
						<FaChevronLeft className="w-5 h-5 text-gray-800" />
					</button>
					<button
						type="button"
						onClick={nextSlide}
						className="absolute right-6 z-30 top-1/2 opacity-0 group-hover:opacity-100 -translate-y-1/2 
        bg-white/80 hover:bg-white p-3 rounded-full shadow-lg transition-all"
						aria-label="Next slide"
					>
						<FaChevronRight className="w-5 h-5 text-gray-800" />
					</button>
				</>
			)}

			{slides.length > 1 && (
				<div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-30">
					{slides.map((_, index) => (
						<button
							type="button"
							key={index}
							onClick={() => goToSlide(index)}
							className={`h-2 rounded-full transition-all duration-300 ${
								currentSlide === index
									? "bg-[#FFB7CF] w-8 shadow-md"
									: "bg-white/60 w-2 hover:bg-white/80"
							}`}
							aria-label={`Go to slide ${index + 1}`}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default Banner;
